/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Clear_Logs_AriaInputs */



/**
* | output |
* | --- |
* | "Clear Logs" |
*
* @param {Drastic_Tech_Clear_Logs_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_clear_logs_aria = /** @type {((inputs?: Drastic_Tech_Clear_Logs_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Clear_Logs_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Effacer les journaux")
	if (locale === "de") return /** @type {LocalizedString} */ ("Protokolle löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cancella registri")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Очистить журналы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Borrar registros")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("清除日志")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ログをクリアする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लॉग साफ़ करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Limpar registros")
	return /** @type {LocalizedString} */ ("Clear Logs")
});